import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MarketProjectPage } from '@/features/marketPromotion/pages/MarketProjectPage';
import { marketProjectSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/projects')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.PROJECT_VIEW),
  validateSearch: marketProjectSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Project">
      <Suspense fallback={<PageLoader />}>
        <MarketProjectPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
